module.exports = __webpack_public_path__ + "img/wc-beautique-hotels.fa1ceaf0.jpg";